module.exports = __webpack_public_path__ + "static/media/fillopacity-icon.e1be1ab4.svg";